import { render, staticRenderFns } from "./ExcalidrawModal.vue?vue&type=template&id=3b5344e4&scoped=true"
import script from "./ExcalidrawModal.vue?vue&type=script&lang=js"
export * from "./ExcalidrawModal.vue?vue&type=script&lang=js"
import style0 from "./ExcalidrawModal.vue?vue&type=style&index=0&id=3b5344e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5344e4",
  null
  
)

export default component.exports